
























































































import { Component, Prop, PropSync, Watch, Vue } from "vue-property-decorator";
import store from "@/store";
//  types
import { FeatureAttribute } from "@/types/cds/featureAttribute";
import { ExtendedVessel } from "@/types/vessel";
//  modules
import { getModule } from "vuex-module-decorators";
import CdsModule from "@/store/clients/Cds.module";

const Cds = getModule(CdsModule, store);

@Component({})
export default class CdsFeatureSelectDialog extends Vue {
  @PropSync("value", { required: true }) isModalActive!: boolean;
  @PropSync("maxWidth", { default: 1000 }) dialogWidth!: number;
  @Prop({ required: true }) selectedVessel!: ExtendedVessel;

  allFeatures: FeatureAttribute[] | undefined = [];
  filteredFeatures: FeatureAttribute[] | undefined = [];
  featureSearch = "";

  @Watch("isModalActive")
  onModalActive(currentState: boolean): void {
    if (!currentState) return;
    this.featureSearch = "";
  }

  @Watch("featureSearch")
  onFeatureSearchInput(featureSearch: string): void {
    if (!featureSearch) {
      this.filteredFeatures = this.allFeatures;
    }
    if (!this.filteredFeatures) return;
    this.filteredFeatures = this.filteredFeatures.filter((feature: FeatureAttribute) => feature.name.toLowerCase().includes(featureSearch.toLowerCase()));
  }

  close(): void {
    this.isModalActive = false;
    this.resetVariables();
  }

  resetVariables(): void {
    this.featureSearch = "";
  }

  setSelectedFeature(feature: FeatureAttribute): void {
    this.isModalActive = false;
    this.featureSearch = "";
    this.$emit("featureSelected", feature);
  }

  async created(): Promise<void> {
    await Cds.fetchVesselFeatures(this.selectedVessel.id);
    this.allFeatures = Cds.featuresByVessel(this.selectedVessel.id);
    this.filteredFeatures = this.allFeatures;
  }
}
